export enum MailjetStatusType {
    Undefined = 0,
    Unknown = 1,
    Queued = 2,
    Sent = 3,
    Opened = 4,
    Clicked = 5,
    Bounce = 6,
    Spam = 7,
    Unsub = 8,
    Blocked = 9,
    Hardbounced = 10,
    Softbounced = 11,
    Deferred = 12,
    NotProcessed = 13
}
